import moment from "dayjs";

export const DefaultValue = {
    startDate : moment().subtract(28, "days").toDate(),
    endDate : moment().subtract(1, "days").toDate(),
    typeReport : "lateSoonFrequency"
}
